import React from 'react';

//Notificaciones
import { ToastContainer } from 'react-toastify';

//Componentes
import { Container, Row, Col } from 'reactstrap';

const Layout = ({ component: Component, ...props }) => {
	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={4000}
				hideProgressBar={true}
				newestOnTop={false}
				closeButton={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss={true}
				draggable={true}
				pauseOnHover={true}
			/>
			<Container fluid>
				<Row>
					<Col lg="12" className="navBarRGPD">
						<Component {...props} />
					</Col>
				</Row>
			</Container>
		</>
	);
};

export default Layout;
